import {createContext as $jDLp7$createContext} from "react";
import $jDLp7$macrostrathyper from "@macrostrat/hyper";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $c16db2d2eed1737e$exports = {};

$parcel$export($c16db2d2eed1737e$exports, "AssetPathContext", () => $c16db2d2eed1737e$export$a438da98986988b5);
$parcel$export($c16db2d2eed1737e$exports, "AssetPathProvider", () => $c16db2d2eed1737e$export$7e80bfe2b93acf4f);
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */ 

const $c16db2d2eed1737e$export$a438da98986988b5 = (0, $jDLp7$createContext)({
    resolveSymbol () {
        return null;
    }
});
function $c16db2d2eed1737e$export$7e80bfe2b93acf4f(props) {
    const { children: children, resolveSymbol: resolveSymbol } = props;
    return (0, $jDLp7$macrostrathyper)(// @ts-ignore
    $c16db2d2eed1737e$export$a438da98986988b5.Provider, {
        value: {
            resolveSymbol: resolveSymbol
        }
    }, children);
}


export {$c16db2d2eed1737e$export$a438da98986988b5 as AssetPathContext, $c16db2d2eed1737e$export$7e80bfe2b93acf4f as AssetPathProvider};
//# sourceMappingURL=column-components.83a2f702.js.map
